<template>
  <v-container class="ma-0 pa-0" fluid>
    <v-card-title class="headline font-weight-regular justify-space-between primary--text">Unlock content
      <v-spacer></v-spacer>

      <v-btn class="mx-2" fab dark small elevation="0" color="primary" @click="closeDialog()">
        <v-icon dark>icons8-multiply</v-icon>
      </v-btn>

    </v-card-title>

    <v-divider class="secondary"></v-divider>

    <v-row class="mx-2">

      <vue-snotify></vue-snotify>

      <v-col cols="12" xs-5 sm-12>
        <v-img :aspect-ratio="16 / 9" height="150" src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"></v-img>
      </v-col>
   
      <v-col cols="12">
        <p class="headline font-weight-regular justify-space-between secondary--text"> Next steps</p>
        <v-divider class="secondary"></v-divider>

        <v-window v-model="step">
          <v-window-item :value="1">
            <v-row class="mx-2">
              <v-col cols="12" xs="12" sm="8">Do you have your unlock code?</v-col>

              <v-col cols="12" xs="12" sm="4" class="text-right">
                <v-btn class="gray mr-2" @click="step = 2">No</v-btn>
                <v-btn class="primary" @click="step = 3">Yes</v-btn>
              </v-col>
            </v-row>
          </v-window-item>
          
          <v-window-item :value="2">
            <v-row class="mx-2">
              <v-col cols="12" xs="12" sm="4" class="text-right">
                <v-btn class="gray mr-2" v-on:click="closeDialog()">Cancel</v-btn>
              </v-col>
            </v-row>
          </v-window-item>

          <v-window-item :value="3">
            <v-row class="mx-2">
              <v-col cols="12" xs="12" sm="8">Enter your Access Code from the confirmation email, it should be in the format xxxx-xxxx</v-col>
              <v-col cols="12" xs="12" sm="4" class="text-right">
                <v-row justify="end">
                  <v-text-field solo v-model.trim="accessCode" hide-details="auto" label="ACCESS CODE" class="mr-2"></v-text-field>
                  <v-btn height="47" class="mt-2 primary" @click="verifyCode()">Verify Code</v-btn>
                </v-row>
                <p v-if="notValid === true" class="error--text">{{ notValidCodeMessage }}</p>
                <p v-if="notValid1 === true" class="error--text">{{ notValidCodeMessage1 }}</p>
              </v-col>
            </v-row>
          </v-window-item>

          <v-window-item :value="4">
            <v-row class="mx-2">
              <v-col cols="12" xs="12" sm="8"
                >Your Access Code has been verified. <br />
                Please be aware the Topics are only accesible for 365 days once they
                have been Activated, you can choose to Activate the Topics when you
                are ready to use it. <br />
                So we can continue to create great content could you help us by
                filling out the following details.
              </v-col>
              <v-col cols="12" xs="12" sm="4">

                <v-text-field v-model="accessCode" hide-details="auto" solo readonly>
                  <v-icon slot="append" color="success">icons8-checked-checkbox-2</v-icon>
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-form ref="courses" v-model="valid" lazy-validation>
                  <v-row>

                    <v-col cols="12" xs="12" sm="6">
                      <v-autocomplete
                        v-model="coursesForm.localAuthorityCountyName"
                        :items="locationDropdown"
                        :filter="customFilter"
                        item-text="name"
                        solo
                        append-icon="icons8-location-2"
                        hide-details="auto"
                        label="Local Authority County"
                        required
                        :rules="requiredRules"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" xs="12" sm="6">
                      <v-text-field
                        v-model="coursesForm.numberOfParticipants"
                        solo
                        append-icon="icons8-user-group"
                        hide-details="auto"
                        label="Number of Participants"
                        type="number"
                        required
                        :rules="[numberRule]"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" xs="12" sm="6">
                      <v-select
                        v-model="coursesForm.ageGroupOfParticipants"
                        solo
                        :items="ageGroups"
                        multiple
                        append-icon="icons8-group-task-2"
                        hide-details="auto"
                        label="Participants Age Group"
                        required
                        :rules="requiredRules"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" xs="12" sm="6">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="coursesForm.estimatedDeliveryDate"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="coursesForm.estimatedDeliveryDate"
                            label="Estimate Course Delivery Date"
                            append-icon="icons8-clock-2"
                            solo
                            readonly
                            v-on="on"
                            hide-details="auto"
                            required
                            :rules="requiredRules"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="coursesForm.estimatedDeliveryDate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            text
                            color="primary"
                            @click="
                              $refs.menu.save(coursesForm.estimatedDeliveryDate)
                            "
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>

              <v-col cols="12" class="text-right">
                <v-btn class="gray mr-2" v-on:click="closeDialog()"> Cancel</v-btn>
                <v-btn class="primary" @click="unlockTopic()">Unlock</v-btn>
              </v-col>
            </v-row>
          </v-window-item>
        </v-window>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "UnlockContentPopUp",
  props: {
  },
  data: () => ({
    step: 1,
    accessCode: "",
    menu: false,
    menu1: false,
    valid: true,
    ageGroups: [
      "Reception",
      "Year 1",
      "Year 2",
      "Year 3",
      "Year 4",
      "Year 5",
      "Year 6",
      "Year 7",
    ],
    locationDropdown: [
      {name:'Blaenau Gwent County Borough'},
      {name:'Bridgend County Borough'},
      { name: "Caerphilly County Borough"},
      { name: "Cardiff"},
      { name: "Carmarthenshire"},
      { name: "Ceredigion"},
      { name: "Conwy County Borough"},
      { name: "Denbighshire"},
      { name: "Flintshire"},
      { name: "Gwynedd"},
      { name: "Isle of Anglesey"},
      { name: "Merthyr Tydfil"},
      { name: "Monmouthshire"},
      { name: "Neath Port Talbot"},
      { name: "Newport"},
      { name: "Pembrokeshire"},
      { name: "Powys"},
      { name: "Rhondda Cynon Taf"},
      { name: "Swansea"},
      { name: "The Vale of Glamorgan"},
      { name: "Torfaen"},
      { name: "Wrexham"},
      { name: "England"},
      { name: "Scotland"},
      { name: "Northern Ireland"},
    ],
    requiredRules: [(v) => !!v || "This field is required"],
    numberRule: val => {
      if(val < 0) return 'Please enter a positive number'
      return true
    },
    coursesForm: {
      id: "",
      name: "",
      numberOfParticipants: "",
      ageGroupOfParticipants: [],
      estimatedDeliveryDate: "",
      userID: "",
      topicName: "",
      topicId: "",
      codeRef: "",
      authorised: true,
      createdBy: "",
      modifiedBy: "",
      createdByID: "",
      createdByEmail: "",
      schoolName: "",
      modifiedByID: "",
      createdTimestamp: "",
      modifiedTimestamp: "",
      expiryDate: "",
      localAuthorityCountyName: ""
    },
    codesForm: {},
    validCode: [],
    notValidCodeMessage: "The code you entered is not valid",
    notValidCodeMessage1: "The code you entered is in use",
    notValid: false,
    notValid1:false,
    today: "",
  }),
  watch: {
    closeDialog: function(val) {
      if(val) {
        this.accessCode = '';
        this.validCode = [];
        this.notValid = false; this.notValid1 = false;
        this.codesForm = {};
        this.resetCourse();
      }
    }
  },
  methods: {
     customFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1;
    },
    verifyCode() {

      var Data = [];
      var self = this;
      this.validCode = [];

      this.$firebase.db
        .collection("codes")
        .where("code", "==", self.accessCode)
        .get()
        .then(function(querySnapshot) {
          //show error message if no such code was found in the db
          if (querySnapshot.docs.length === 0) {
            self.notValid = true;
          }
          querySnapshot.forEach(function(doc) {
            Data = doc.data();
            Data.id = doc.id;
            self.validCode.push(Data);
            if(self.validCode[0].used){
              self.notValid1 = true;
            }else{
              self.step = 4;
            }
             //move to the next step if code was found
          });
        })
        .catch(function(error) {
         // console.log("Error getting documents: ", error);
        });
    },

    generateID() {
      return "xxxxyxxx-yxxx-xxxxxx".replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    unlockTopic() {
      if (this.$refs.courses.validate()) {
        this.coursesForm.id = this.generateID();
        this.coursesForm.name = '';
        this.coursesForm.userID = this.$store.getters.currUser.id;
        this.coursesForm.codeRef = this.accessCode;
        this.coursesForm.authorised = true;
        this.coursesForm.topicName = "ALL"
        this.coursesForm.schoolName = this.$store.getters.currUser.schoolName;
        this.coursesForm.createdBy = this.$store.getters.currUser.fullName;
        this.coursesForm.createdByID = this.$store.getters.currUser.id;
        this.coursesForm.createdByEmail = this.$store.getters.currUser.email;
        this.coursesForm.createdTimestamp = this.$moment().toISOString();
        this.coursesForm.estimatedDeliveryDate = this.$moment(this.coursesForm.estimatedDeliveryDate).toISOString();
              var date = this.$moment(); //new Date();

        this.coursesForm.expiryDate = this.$moment(date.add(365, "d")).toISOString();

        //console.log('courses form: ' + JSON.stringify(this.coursesForm, null, 2));
        var self = this;
        self.$firebase.db
          .collection("courses")
          .doc(self.coursesForm.id)
          .set(self.coursesForm)
          .then((docRef) => {
            self.$snotify.info("The topics were unlocked.");
          })
          .catch((error) => {
            self.$snotify.error(error);
          });
        
        this.codesForm.usedBy = this.$store.getters.currUser.fullName
        this.codesForm.schoolName =this.$store.getters.currUser.schoolName
        this.codesForm.usedById =this.$store.getters.currUser.id
        this.codesForm.usedTimestamp = this.$moment().toISOString();
        this.codesForm.used = true;
        this.codesForm.expirationDate= this.$moment().add(365, "d").toISOString();
        self.$firebase.db.collection("codes").doc(self.validCode[0].id).update(self.codesForm).then((docRef) => {
          })
          .catch((error) => {
            self.$snotify.error(error);
          });

        this.$store.getters.currUser.code = this.accessCode
        var userForm = {}
        userForm.code = this.accessCode;
        self.$firebase.db.collection("users").doc(this.$store.getters.currUser.id).update(userForm).then((docRef) => {
          })
          .catch((error) => {
            self.$snotify.error(error);
          });

        self.closeDialog();
      } else {
        this.$snotify.error("Fill out all the fields in order to proceed.");
      }
    },
  resetCourse(){
      this.coursesForm.id = "";
      this.coursesForm.name = "";
      this.coursesForm.numberOfParticipants = "";
      this.coursesForm.ageGroupOfParticipants = [];
      this.coursesForm.estimatedDeliveryDate = "";
      this.coursesForm.userID = "";
      this.coursesForm.topicName = "";
      this.coursesForm.topicId = "";
      this.coursesForm.codeRef = "";
      this.coursesForm.authorised = "";
      this.coursesForm.createdBy = "";
      this.coursesForm.modifiedBy = "";
      this.coursesForm.createdByID = "";
      this.coursesForm.modifiedByID = "";
      this.coursesForm.createdByEmail = "";
      this.coursesForm.createdTimestamp = "";
      this.coursesForm.modifiedTimestamp = "";
      this.coursesForm.expiryDate = "";
    },
    closeDialog() {
      this.step = 1;
      this.accessCode = "";
      this.validCode = [];
      this.notValid = false;
      this.notValid1 = false;
      this.coursesForm = {};
      this.$emit("close-dialog");
    },
  },
};
</script>
